// extracted by mini-css-extract-plugin
module.exports = {"container":"ButtonWithIcon_container__1xUSJ","iconContainer":"ButtonWithIcon_iconContainer__SjWaW","text":"ButtonWithIcon_text__1oWhm","active":"ButtonWithIcon_active__AwTdZ"};